import { useContext, useEffect } from 'react';
import CustomerConfigurationContext from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import { useValidation } from 'src/easyclaim.app.contexts/ValidationContextCore';
import { useContinueButtonStore } from 'src/easyclaim.app.stores/useContinueButtonStore';

export function ValidationDisabledSync() {
	const { isNextBlockedByValidation, hasNonCorrectValidation } = useValidation();
	const customerConfig = useContext(CustomerConfigurationContext).configuration;
	const setValidationDisabled = useContinueButtonStore((s) => s.setValidationDisabled);

	useEffect(() => {
		if (customerConfig?.showUpdatedVerificationResults) {
			setValidationDisabled(hasNonCorrectValidation);
		} else if (customerConfig?.canScrollToMissingPhoto) {
			setValidationDisabled(isNextBlockedByValidation);
		} else {
			setValidationDisabled(false);
		}
	}, [
		customerConfig?.showUpdatedVerificationResults,
		customerConfig?.canScrollToMissingPhoto,
		hasNonCorrectValidation,
		isNextBlockedByValidation,
		setValidationDisabled,
	]);

	return null;
}
